/**
 * @fileoverview PUT handler for the "/companies/:company_id/oauth_mcp_settings/partner_apps_enabled" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsPartnerAppsEnabledCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabledProps,
  PutCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabledResult,
} from "./types";

export const putCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabled = reactQueryMutationAdapter(
  companiesCompanyIdOauthMcpSettingsPartnerAppsEnabledCacheKeys,
  (
    props: PutCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabledProps
  ): Promise<PutCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabledResult> => {
    return fetch(
      `/companies/${props.company_id}/oauth_mcp_settings/partner_apps_enabled`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
